// src/pages/DeviceTypeManagement/DeviceTypeList.jsx
import React from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  TextField,
  Typography,
  InputAdornment,
  Chip
} from '@mui/material';
import {
  Search as SearchIcon,
  Devices as DevicesIcon
} from '@mui/icons-material';

const DeviceTypeList = ({ deviceTypes, selectedDeviceType, onSelectDeviceType, searchTerm, onSearchChange }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Search */}
      <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
        <TextField
          fullWidth
          size="small"
          placeholder="Search device types..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            )
          }}
        />
      </Box>

      {/* Device Type List */}
      <List sx={{ flex: 1, overflow: 'auto', p: 0 }}>
        {deviceTypes.length === 0 ? (
          <Box sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              No device types found
            </Typography>
          </Box>
        ) : (
          deviceTypes.map((deviceType) => (
            <ListItem key={deviceType.id} disablePadding>
              <ListItemButton
                selected={selectedDeviceType?.id === deviceType.id}
                onClick={() => onSelectDeviceType(deviceType)}
                sx={{
                  borderLeft: 3,
                  borderColor: selectedDeviceType?.id === deviceType.id ? 'primary.main' : 'transparent'
                }}
              >
                <ListItemText
                  primary={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <DevicesIcon fontSize="small" color="primary" />
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: selectedDeviceType?.id === deviceType.id ? 600 : 400
                        }}
                      >
                        {deviceType.FrontEndName || deviceType.friendlyName || `Device Type ${deviceType.id}`}
                      </Typography>
                    </Box>
                  }
                  secondary={
                    <Box sx={{ mt: 0.5, display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                      <Chip
                        label={deviceType.friendlyName || `ID: ${deviceType.id}`}
                        size="small"
                        variant="outlined"
                        sx={{ fontFamily: 'monospace', fontSize: '0.7rem' }}
                      />
                      {deviceType.defaultServices?.length > 0 && (
                        <Chip
                          label={`${deviceType.defaultServices.length} services`}
                          size="small"
                          color="primary"
                          sx={{ fontSize: '0.7rem' }}
                        />
                      )}
                    </Box>
                  }
                />
              </ListItemButton>
            </ListItem>
          ))
        )}
      </List>
    </Box>
  );
};

export default DeviceTypeList;
